const siteConfig = {
    languages: ["fa"],
    // languages: ["fa", "en"],

    defaultLng: 'fa',
    dontShowUrlForDefaultLng: true,
    forceUrl: true,


    showCart: true,
    showProfile: true,
    showLanguage: true,
    showDeliveryCalcText: false,




    // rootDomain: 'http://127.0.0.1:5081/kheiri/',
    // domain: 'http://127.0.0.1:5081/kheiri/',
    // // assetsDomain: 'https://rira.yonnect.ir/assets/',
    // socketDomain: 'http://127.0.0.1:5082/',

    //testttttttttttt
    // rootDomain: 'https://test.iranhorse.net/',
    // domain: 'https://test.iranhorse.net/iranhorse/',
    // assetsDomain: 'https://test.iranhorse.net/assets/',
    // // assetsDomain: 'sepeniccdn.elitive.ir/',
    // socketDomain: 'https://test.iranhorse.net/',


    //maiinnnnnnn
    
    rootDomain: 'https://bpms.iranhorse.net/',
    domain: 'https://bpms.iranhorse.net/iranhorse/',
    assetsDomain: 'https://bpms.iranhorse.net/assets/',
    // assetsDomain: 'sepeniccdn.elitive.ir/',
    socketDomain: 'https://bpms.iranhorse.net/',

    // rootDomain: 'http://madarek.yonnect.ir/',
    // domain: 'http://madarek.yonnect.ir/kheiri/',
    // assetsDomain: 'http://madarek.yonnect.ir/assets/',
    // // assetsDomain: 'https://sepeniccdn.elitive.ir/',
    // socketDomain: 'http://madarek.yonnect.ir/',



    name: 'IHP',
    siteName: 'IHP',
    phone: '021-XXXX XXXX',
    facebook: '',
    canSignup: false,
    // Role preview and fake dashboard data are opt-in so a production build
    // cannot accidentally expose the test switcher.
    testEnv: false,
    showAdminWidgets: true,
    showAdminWidgetsHome: true,
    showAdminWidgetsBranch: true,
}

const siteTheme = {

    description: 'پلتفرم کسب و کار',
    logo: '/images/kheiry/mainLogo.png',
    logo2: '/images/kheiry/mainLogo2.png',
    logo_old: '/images/kheiry/mainLogo.png',
    logo_s: '/images/kheiry/mainLogo.png',
    // invertLogo: true,


    themeColors: { headerBack: '#f2f7f8', headerFont: '#000000' },
    // themeColors: { headerBack: '#46196f', headerFont: '#ffffff' },
    // themeColors: { headerBack: '#000000', headerFont: '#ffffff' },


    // Primary color scheme
    primaryColors: {
        main1: '#10453d',      // Darker green - primary color
        main2: '#146a5d',       // Teal - used alongside green in gradients
        main3: '#e2c19e'       // Beige - accent color for beautiful touches
    },

    backgroundColors: { normal: '#e2e8ea', plus: '#ee5050', luxury: '#101010', custom: '#d3b564' },
    colors: { normal: '#202020', plus: '#fff', luxury: '#fff', custom: '#101010' },
}

const languagesInfo = {
    // en: {
    //     shortName: 'en',
    //     direction: 'ltr',
    //     name: 'English',
    //     icon: '/images/language/english.svg'
    // },
    fa: {
        shortName: 'fa',
        direction: 'rtl',
        name: 'فارسی',
        icon: '/images/language/persian.svg'
    }
}


let apisList = {

    // *************************************** Documents And Records APIS List *******************************************

    getApplet: { route: 'applets/getApplet', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getApplets: { route: 'applets/getApplets', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postApplet: { route: 'applets/postApplet', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeApplet: { route: 'applets/removeApplet', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getMyApplets: { route: 'applets/getMyApplets', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getRecords: { route: 'records/getRecords', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document
    getUserRecords: { route: 'records/getUserRecords', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document
    exportRecordPdf: { route: 'records/exportRecordPdf', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postRecord: { route: 'records/postRecord', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document
    changeCurrentStatus: { route: 'records/changeCurrentStatus', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeRecord: { route: 'records/removeRecord', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document
    getChartInfo: { route: 'records/getChartInfo', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document
    getRecordsCount: { route: 'records/getRecordsCount', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document


    // EMPLOYEES


    employeeLogin: { route: 'employees/authenticate', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    employeeAdd: { route: 'employees/add', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    employeeUpdatePassword: { route: 'employees/employeeUpdatePassword', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    employeeGetAll: { route: 'employees/getAll', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    employeeRemove: { route: 'employees/remove', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    employeeGetInfo: { route: 'employees/getInfo', server: 'yc', hashMethod: '', auth: 'token', params: [], auth: 'token', flexibleParams: true },
    getEmployees: { route: 'employees/getAll', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    
    // employeeGetAll: { route: 'migrator/addFormIdToRecords', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // employeeGetAll: { route: 'migrator/fixEmployeesUserType', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },


    blockAdmin: { route: 'employees/blockAdmin', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // blockAdmin: { route: 'employees/blockAdmin', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    logout: { route: 'employees/logout', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    permissionDenied: { route: 'employees/permissionDenied', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },

    terminateAdminSessions: { route: 'adminSessions/terminateAdminSessions', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },



    getPermissions: { route: 'permissions/get', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addPermission: { route: 'permissions/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removePermission: { route: 'permissions/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getPermission: { route: 'permissions/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    //getMyadminSessions
    getMyadminSessions: { route: 'adminSessions/getMyadminSessions', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeAdminSession: { route: 'adminSessions/removeSession', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    // USER
    userCheck: { route: 'users/check', server: 'yc', hashMethod: '', auth: 'token', flexibleParams: true },
    checkUsername: { route: 'employees/checkUsername', server: 'yc', hashMethod: '', auth: '', flexibleParams: true },
    userSignup: { route: 'employees/signup', server: 'yc', hashMethod: '', auth: '', flexibleParams: true },
    blockUser: { route: 'users/blockUser', server: 'yc', hashMethod: '', auth: 'token', flexibleParams: true },
    userLogin: { route: 'employees/authenticate', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // logout: { route: 'users/logout', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    userSendCode: { route: 'users/signup/verifyCode', server: 'yc', hashMethod: '', auth: 'token', flexibleParams: true },
    //Todo create user
    userPostInfo: { route: 'users/signup/postInfo', server: 'yc', hashMethod: '', auth: 'token', flexibleParams: true },
    userForgetPassword: { route: 'users/forgotPassword', server: 'yc', hashMethod: '', auth: 'token', flexibleParams: true },
    userForgetPasswordVerifyCode: { route: 'users/forgotPassword/verifyCode', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    userForgetPasswordPostPassword: { route: 'users/forgotPassword/postPassword', server: 'yc', hashMethod: '', auth: 'token', flexibleParams: true },
    userUpdate: { route: 'users/add', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    userGetAll: { route: 'users/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    userRemove: { route: 'users/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    userGetInfo: { route: 'users/getInfo', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    userAuthVerifyCode: { route: 'users/signin/verifyCode', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    userUpdateInfo: { route: 'users/updateInfo', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    userRegisterDevice: { route: 'users/registerDevice', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    userUnregisterDevice: { route: 'users/unregisterDevice', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },

    terminateUserSessions: { route: 'sessions/terminateUserSessions', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },

    // Contents
    getContents: { route: 'content/getContents', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postContent: { route: 'content/postContent', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeContent: { route: 'content/removeContent', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // permissions
    // addPermission: { route: 'permissions/addPermission', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // getPermissions: { route: 'permissions/getPermissions', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // removePermission: { route: 'permissions/removePermission', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // getOnePermissions: { route: 'permissions/getOnePermissions', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },

    //logs
    getLogs: { route: 'logs/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    readLog: { route: 'logs/readLog', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // settings
    getSettings: { route: 'settings/getSettings', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    applySettings: { route: 'settings/postSettings', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // branches
    getBranches: { route: 'branches/getBranches', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postBranch: { route: 'branches/postBranch', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    removeBranch: { route: 'branches/removeBranch', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    // colors
    getColors: { route: 'colors/getColors', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postColor: { route: 'colors/postColor', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    removeColor: { route: 'colors/removeColor', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    // cars
    getCars: { route: 'cars/getCars', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postCar: { route: 'cars/postCar', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    removeCar: { route: 'cars/removeCar', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    // forms
    getForms: { route: 'forms/getForms', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postForm: { route: 'forms/postForm', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    removeForm: { route: 'forms/removeForm', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },

    // document Type
    getDocumentType: { route: 'documentType/getDocumentType', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postDocumentType: { route: 'documentType/postDocumentType', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    removeDocumentType: { route: 'documentType/removeDocumentType', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    //import
    submitImport: { route: 'imports/submitImport', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // distribution List
    getDistributionList: { route: 'distributionList/getDistributionList', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postDistributionList: { route: 'distributionList/postDistributionList', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    removeDistributionList: { route: 'distributionList/removeDistributionList', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },

    // DocumentGroup
    getDocumentGroup: { route: 'documentGroup/getDocumentGroup', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postDocumentGroup: { route: 'documentGroup/postDocumentGroup', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    removeDocumentGroup: { route: 'documentGroup/removeDocumentGroup', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },

    // DynamicCodes
    getDynamicCodes: { route: 'dynamicCodes/getDynamicCodes', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postDynamicCodes: { route: 'dynamicCodes/postDynamicCodes', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    // removeDynamicCodes: { route: 'dynamicCodes/removeDynamicCodes', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    // RecordsGroup
    getRecordsGroup: { route: 'recordsGroup/getRecordsGroup', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postRecordsGroup: { route: 'recordsGroup/postRecordsGroup', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    removeRecordsGroup: { route: 'recordsGroup/removeRecordsGroup', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },

    // Responsibilities
    getResponsibilities: { route: 'responsibilities/getResponsibilities', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postResponsibilities: { route: 'responsibilities/postResponsibilities', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    removeResponsibilities: { route: 'responsibilities/removeResponsibilities', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },

    // CreateRecord
    getCreateRecord: { route: 'createRecord/getCreateRecord', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postCreateRecord: { route: 'createRecord/postCreateRecord', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeCreateRecord: { route: 'createRecord/removeCreateRecord', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    getMyRecord: { route: 'createRecord/getMyRecord', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneMyRecord: { route: 'createRecord/getOneMyRecord', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // workflow
    getWorkflow: { route: 'workflow/getWorkflow', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postWorkflow: { route: 'workflow/postWorkflow', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    removeWorkflow: { route: 'workflow/removeWorkflow', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },

    // chart
    getChart: { route: 'chart/getChart', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postChart: { route: 'chart/postChart', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    removeChart: { route: 'chart/removeChart', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    // AutoGens
    getAutoGens: { route: 'autoGens/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addAutoGen: { route: 'autoGens/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeAutoGen: { route: 'autoGens/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // jobs
    getJobs: { route: 'jobs/getJobs', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postJobs: { route: 'jobs/postJobs', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    removeJobs: { route: 'jobs/removeJobs', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },

    // processes
    getProcesses: { route: 'processes/getProcesses', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    postProcesses: { route: 'processes/postProcesses', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },
    removeProcesses: { route: 'processes/removeProcesses', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },

    // createDocument
    getAllDocument: { route: 'createDocument/getAllDocument', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true }, // GET ALL
    postCreateDocument: { route: 'createDocument/postCreateDocument', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Post
    removeCreateDocument: { route: 'createDocument/removeCreateDocument', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true }, //Remove
    getMyDocuments: { route: 'createDocument/getMyDocuments', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // My Document
    getMyDocumentRequests: { route: 'createDocument/getMyDocumentRequests', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // My Document
    getMyDocumentsConsultation: { route: 'createDocument/getMyDocumentsConsultation', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // My Document
    getMyNotifiedDocuments: { route: 'createDocument/getMyNotifiedDocuments', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // My Document
    approveConsultation: { route: 'createDocument/approveConsultation', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // My Document
    getOneDocument: { route: 'createDocument/getOneDocument', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get One
    getMyCreateDocument: { route: 'createDocument/getMyCreateDocument', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document
    approveDocument: { route: 'createDocument/approveDocument', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document
    nextWorkflowStep: { route: 'createDocument/nextWorkflowStep', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document
    getEditDocument: { route: 'createDocument/getEditDocument', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document
    editCreateDocument: { route: 'createDocument/editCreateDocument', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document
    //report    
    homePageChartDocs: { route: 'createDocument/homePageChartDocs', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document
    finishDocument: { route: 'createDocument/finishDocument', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Finish Document


    getActiveDocument: { route: 'createDocument/getActiveDocument', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get Active Document
    getDeprecateDocument: { route: 'createDocument/getDeprecateDocument', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get Active deprecate
    seeOneDocument: { route: 'createDocument/seeOneDocument', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // See One Doucument Just For See

    //inboxes
    getMyInbox: { route: 'inboxes/getMyInbox', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document

    //sync
    initConfig: { route: 'sync/initConfig', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, // Get My Create Document

    // *************************************** Energy APIS List *******************************************

    // Energy Carriers  
    getEnergyCarriers: { route: 'energyCarriers/getEnergyCarriers', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postEnergyCarriers: { route: 'energyCarriers/postEnergyCarriers', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeEnergyCarriers: { route: 'energyCarriers/removeEnergyCarriers', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // List Of Energy Uses
    getListOfEnergyUses: { route: 'listOfEnergyUses/getListOfEnergyUses', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postListOfEnergyUses: { route: 'listOfEnergyUses/postListOfEnergyUses', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeListOfEnergyUses: { route: 'listOfEnergyUses/removeListOfEnergyUses', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // Evaluation Parameters  
    getEvaluationParameters: { route: 'evaluationParameters/getEvaluationParameters', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postEvaluationParameters: { route: 'evaluationParameters/postEvaluationParameters', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeEvaluationParameters: { route: 'evaluationParameters/removeEvaluationParameters', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // Effective Factors  
    getEffectiveFactors: { route: 'effectiveFactors/getEffectiveFactors', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postEffectiveFactors: { route: 'effectiveFactors/postEffectiveFactors', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeEffectiveFactors: { route: 'effectiveFactors/removeEffectiveFactors', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // Public Variable 
    getPublicVariable: { route: 'publicVariable/getPublicVariable', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postPublicVariable: { route: 'publicVariable/postPublicVariable', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removePublicVariable: { route: 'publicVariable/removePublicVariable', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // Operation Control
    getOperationControl: { route: 'operationControl/getOperationControl', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postOperationControl: { route: 'operationControl/postOperationControl', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeOperationControl: { route: 'operationControl/removeOperationControl', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // Energy Indicators
    getEnergyIndicators: { route: 'energyIndicators/getEnergyIndicators', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postEnergyIndicators: { route: 'energyIndicators/postEnergyIndicators', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeEnergyIndicators: { route: 'energyIndicators/removeEnergyIndicators', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // Energy Products
    getEnergyProducts: { route: 'energyProducts/getEnergyProducts', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postEnergyProducts: { route: 'energyProducts/postEnergyProducts', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeEnergyProducts: { route: 'energyProducts/removeEnergyProducts', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // Energy Products
    getOpportunitiesImprovement: { route: 'opportunitiesForImprovement/getOpportunitiesImprovement', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postOpportunitiesImprovement: { route: 'opportunitiesForImprovement/postOpportunitiesImprovement', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeOpportunitiesImprovement: { route: 'opportunitiesForImprovement/removeOpportunitiesImprovement', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // Standard Clause
    getStandardClause: { route: 'standardClause/getStandardClause', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postStandardClause: { route: 'standardClause/postStandardClause', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeStandardClause: { route: 'standardClause/removeStandardClause', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // Standard Clause
    getDocumentsPapers: { route: 'documentsPapers/getDocumentsPapers', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postDocumentsPapers: { route: 'documentsPapers/postDocumentsPapers', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeDocumentsPapers: { route: 'documentsPapers/removeDocumentsPapers', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    ExelEquipment: { route: 'exports/ExelEquipment', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    ExelExport: { route: 'exports/excel', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

}


export { siteConfig, siteTheme, languagesInfo, apisList }
